var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cNobgButton-container"},[_c('p',{staticClass:"buttonRound",class:_vm.disabled ? 'disableds' : '',on:{"click":_vm.clickbtn}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebf59b96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button/cNoBgButton.vue
// module id = null
// module chunks = 